<template>
  <div>
    <v-card max-height="700">
      <v-card-title class="cardheader">
        <span class="headline black--text">Import TLE files</span>
        <exo-help-dialog
          :color="'black--text'"
          margin="m-0"
          title="Import TLE files"
        >
          Import a list of TLEs from {{ filesOnly ? 'files' : 'a folder' }}. The
          imported files must only contain valid TLEs, separated by line breaks
          and spaces. Encoding of the files should be UTF-8.
          {{ filesOnly ? '' : 'The folder must only contain valid files.' }}
        </exo-help-dialog>
        <v-spacer></v-spacer>
        <v-btn
          icon
          light
          class="m-0"
          v-on:click="closeDialog()"
          :disabled="importing"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="dialogSectionClass">
          <v-col>
            <v-row>
              <v-text-field
                label="Select..."
                :value="fileName"
                readonly
                prepend-icon="attach_file"
                v-on:click="openFileFinder()"
              ></v-text-field>
              <input
                ref="inputFile"
                type="file"
                :webkitdirectory="!filesOnly"
                files=""
                multiple
                style="display: none"
                @change="getInputFiles"
              />
            </v-row>
            <v-row v-if="importing === true">
              <v-col>
                <v-progress-linear
                  :value="importProgressPercentage"
                  height="25"
                >
                  <template v-slot:default="{ value }">
                    <strong>{{ Math.ceil(value) }}%</strong>
                  </template>
                </v-progress-linear>
              </v-col>
            </v-row>
            <v-row justify="end">
              <v-btn color="primary" @click="importTLEs()" :disabled="!ready"
                >Import</v-btn
              ></v-row
            >
          </v-col>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from '../../services/axios'

import Vue from 'vue'
import VueAxios from 'vue-axios'
import errorMixin from '../../mixins/logHandler.js'
Vue.use(VueAxios, axios)

export default {
  name: 'ManeuverAnalysisToDataGenerationDialogue',

  mixins: [errorMixin],

  props: {
    isOpenDialog: Boolean,
    filesOnly: {
      type: Boolean,
      default: false
    }
  },

  mounted() {},

  watch: {
    importing(newValue) {
      this.$emit('update:importing', newValue)
    }
  },

  data() {
    return {
      fileName: null,
      files: null,
      importing: false,
      currentUploadedSize: 0
    }
  },

  computed: {
    ready() {
      return this.files != null && !this.importing
    },
    totalFileSize() {
      return this.files != null
        ? [...this.files].reduce(
            (sumOfSizes, nextFile) => sumOfSizes + nextFile.size,
            0
          )
        : 0
    },
    importProgressPercentage() {
      if (this.totalFileSize > 0) {
        return (this.currentUploadedSize / this.totalFileSize) * 100
      } else {
        return 0
      }
    }
  },

  methods: {
    closeDialog() {
      this.$emit('update:isOpenDialog', false)
      this.fileName = null
      this.files = null
      this.importing = false
      this.currentUploadedSize = 0
    },
    getInputFiles(event) {
      this.files = event.target.files
      if (this.filesOnly) {
        this.fileName = [...this.files].map((file) => file.name).join(', ')
      } else {
        this.fileName =
          this.files.length !== 0
            ? this.files[0].webkitRelativePath.split('/')[0]
            : null
      }
    },
    async importFilesContents() {
      this.importing = true
      const filesPromises = [...this.files].map((file) =>
        file
          .text()
          .then((text) => {
            return text
          })
          .finally(() => {
            this.currentUploadedSize += file.size
          })
      )
      return Promise.all(filesPromises).catch((error) => {
        this.displayMessage(
          'Error while importing files.',
          error,
          'notification',
          'error'
        )
        return []
      })
    },
    importTLEs() {
      this.importFilesContents()
        .then((filesContents) => {
          this.$emit('update:tleText', filesContents.join('\n'))
        })
        .catch((error) => {
          this.displayMessage(
            'Error while processing files.',
            error,
            'notification',
            'error'
          )
        })
        .finally(() => {
          this.closeDialog()
        })
    },
    openFileFinder() {
      if (!this.importing) {
        this.$refs.inputFile.click()
      }
    }
  }
}
</script>

<style scoped>
.cardheader {
  background: #3be287;
}
.dialogSectionClass {
  margin-top: 4px;
}
</style>
